import styled from 'styled-components';

import { CONTAINER_PADDING } from '@components/blocks/blocks.constants';
import { media } from '@theme/media';

import { containerStyles, paragraphTextStyles } from '../blocks.styles';

export const Container = styled.div`
  ${containerStyles};
`;

export const BlockQuote = styled.blockquote`
  ${paragraphTextStyles};

  margin: 2.8em 0 2.8em ${CONTAINER_PADDING * 1.5}px;

  ${media.tablet} {
    margin-right: ${CONTAINER_PADDING * 1.5}px;
  }
`;
